module.exports = __webpack_public_path__ + "img/padlock.a773ff74.png";